module.exports = __webpack_public_path__ + "static/media/marker10.df641146.png";